import { useState, useRef, useEffect } from 'react';

function useHover(hideOnScroll) {
  const [value, setValue] = useState(false);
  const isTouch = useRef(false);
  const holdTimeOut = useRef(0);
  const ref = useRef(null);
  const handleMouseEnter = () => {
    if (!isTouch.current) {
      setValue(true);
    }
    isTouch.current = false;
  };
  const handleMouseLeave = () => {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };
  const handleTouchStart = () => {
    isTouch.current = true;
    clearTimeout(holdTimeOut.current);
    holdTimeOut.current = window.setTimeout(() => {
      setValue(true);
      isTouch.current = false;
    }, 350);
  };
  const handleTouchEnd = () => {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };
  const handleScroll = () => {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };
  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener("mouseenter", handleMouseEnter);
      node.addEventListener("mouseleave", handleMouseLeave);
      node.addEventListener("touchstart", handleTouchStart);
      node.addEventListener("touchend", handleTouchEnd);
      hideOnScroll && document.addEventListener("scroll", handleScroll, { capture: true });
    }
    return () => {
      clearTimeout(holdTimeOut.current);
      node == null ? void 0 : node.removeEventListener("mouseenter", handleMouseEnter);
      node == null ? void 0 : node.removeEventListener("mouseleave", handleMouseLeave);
      node == null ? void 0 : node.removeEventListener("touchstart", handleTouchStart);
      node == null ? void 0 : node.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("scroll", handleScroll);
    };
  }, [ref, hideOnScroll]);
  return [ref, value];
}

export { useHover };
//# sourceMappingURL=useHover.es.js.map
